import { isErrorCode } from "./error-codes.js";
function isRecord(value) {
    return typeof value === "object" && value !== null;
}
function isMeta(value) {
    return (isRecord(value) &&
        typeof value.requestId === "string" &&
        typeof value.apiVersion === "string" &&
        typeof value.timestamp === "string");
}
/** Runtime check for untrusted JSON (e.g. fetch results) before treating it as an error body. */
export function isApiErrorBody(value) {
    if (!isRecord(value) || value.success !== false || !isMeta(value.meta))
        return false;
    const error = value.error;
    return isRecord(error) && isErrorCode(error.code) && typeof error.message === "string";
}
/** Runtime check for untrusted JSON. Does not validate `data` — callers validate their payload. */
export function isApiSuccess(value) {
    return isRecord(value) && value.success === true && "data" in value && isMeta(value.meta);
}
//# sourceMappingURL=envelope.js.map